<mc-modal
  [class]="'modal-panel-wrapper '"
  [open]="open"
  width="{{ dialogWidth }}"
  height="{{ dialogHeight }}"
  backdropcloseactiondisabled="true"
  (closing)="onSecondaryButtonClick($event)"
>
  <ng-content></ng-content>
  <span class="modal-panel-header" slot="heading">{{ title }}</span>
  @if (withFooter) {
    <div slot="footer">
      <mc-button
        slot="secondaryAction"
        appearance="neutral"
        variant="filled"
        [attr.dialogaction]="closeOnSecondaryAction ? 'cancel' : null"
        fit="medium"
        (click)="onSecondaryButtonClick($event)"
      >
        {{ secondaryButtonLabel ?? "t('cancel_lbl')" }}
      </mc-button>
      <Span class="button-group"></Span>
      <mc-button
        slot="primaryAction"
        [disabled]="primaryButtonDisabled"
        class="modal-panel-primary-action-button"
        appearance="primary"
        fit="medium"
        [attr.dialogaction]="closeOnPrimaryAction ? 'ok' : null"
        (click)="onPrimaryButtonClick($event)"
      >
        {{ primaryButtonLabel ?? "t('save_your_Changes_lbl')" }}
      </mc-button>
    </div>
  }
</mc-modal>
